import customAxios from "./axiosConfig";

const EmailMessageNotificationService = {
  retrieve (pk, params) {
    const api_url = window.Urls['emailmessage_detail'](pk);
    return customAxios.get(api_url, { params: params });
  }
};

export default EmailMessageNotificationService;